export const THEMES = ['primary', 'dark'];
